<template>
  <div>
    <div class="worklist-wrapper">
      <h2>{{table_title}}<button @click="openAdd" class="openAdd">Add Client</button></h2>
      <div class="table">
        <tr class="t-row" style="background-color: #424242;">
          <th class="id-col">id</th>
          <th class="client-name">Client</th>
          <th>Description</th>
          <th>Image URL</th>
          <th class="date-col">Created</th>
          <th class="date-col">Last modified</th>
          <th class="edit"></th>
          <th class="edit"></th>
          <!-- <th class="edit"></th> -->
        </tr>
        <draggable v-model="makers" :move="checkDrag" @end="updateOrder">
          <transition-group name="list-complete">
            <tr class="t-row drag" style="display: table-row;" v-for="maker in makers" :key="maker.m_sort">
              <td class="id-col">{{maker.m_id}}</td>
              <td class="client-name">{{maker.m_name}}</td>
              <td>{{maker.m_descri}}</td>
              <td>{{maker.m_image}}</td>
              <td class="date-col">{{maker.m_createdAt}}</td>
              <td class="date-col">{{maker.m_updatedAt}}</td>
              <td class="edit"><button class="openEdit" @click="openEdit(maker)">edit</button></td>     
              <td class="edit"><button class="openEdit" @click="openWorks(maker)">more</button></td>
              <!-- <td class="edit"><button class="openEdit" @click="openDetail(maker)">add</button></td> -->
            </tr>
          </transition-group>
        </draggable>
      </div>
    </div>
    <AddForm />
<!--####################################################################################################-->
    <div class="edit-wrapper">
      <div class="edit-inner">
        <h2>Edit Project</h2><button class="closeModal" @click="closeModal">X</button>
        
        <div class="input-row">
          <label for="m_name">Project Name</label>
          <input name="m_name" type="text" v-model="m_name">
        </div>
        <div class="input-row">
          <label for="m_descri">Description</label>
          <textarea id="m_descri" name="m_descri" rows="5" cols="40" type="text" v-model="m_descri">
            
          </textarea>
        </div>
        <div class="input-row">
          <label for="m_image">Image URL</label>
          <textarea id="m_image" name="m_image" rows="2" cols="40" type="text" v-model="m_image">
            
          </textarea>
        </div>
        <div class="input-row">
          <label for="m_image">Sort Order</label>
          <input name="m_sort" type="text" v-model="m_sort">
        </div>
        
        <button type="submit" @click="editClient">Update</button> 
        <button type="submit" @click="deleteClient" class="deleteClient">Delete</button>
        
      </div>
    </div>
    <DetailForm :select_maker="select_maker" />
    <ViewDetails :select_maker="select_maker" />
  </div>
</template>

<script>
import axios from 'axios'
import AddForm from './AddForm'
import DetailForm from './DetailForm'
import ViewDetails from './ViewDetails'
import draggable from 'vuedraggable'

export default {
  components: {
    AddForm,
    DetailForm,
    ViewDetails,
    draggable
  },
  created () {
    this.getData()
  },
  data() {
    return {
      table_title: 'Client Table',
      makers: [],
      // maker_works: [],
      modal: false,
      m_id : '',
      m_name: '',
      m_descri: '',
      m_image: '',
      m_sort: '',
      select_maker: [],
    }
  },
  mounted() {
  },
  methods: {
    getData() {
      axios.get('/api/makers')
        .then((response) => {
          this.makers = response.data
        })
    },
    openAdd() {
      var modal = document.querySelector('.input-wrapper')
      modal.style.display = "block"
    },
    openEdit(maker) {
      this.m_id = maker.m_id
      var modal = document.querySelector('.edit-wrapper')
      modal.style.display = "block" 

      this.m_name = maker.m_name
      this.m_descri = maker.m_descri
      this.m_image = maker.m_image
      this.m_sort = maker.m_sort
    },
    openDetail(maker) {
      this.select_maker = maker
      this.m_id = maker.m_id
      var modal = document.querySelector('.detail-input-wrapper')
      modal.style.display = "block" 
    },
    openWorks(maker) {
      this.select_maker = maker
      this.m_id = maker.m_id
      // this.$router.push('/viewdetails')
      var modal = document.querySelector('.view-works-wrapper')
      modal.style.display = "block" 
    },
    closeModal() {
      var modal = document.querySelector('.edit-wrapper')
      modal.style.display = "none"
    },
    editClient() {
      if(!this.m_id || !this.m_name || !this.m_descri || !this.m_image || !this.m_sort) {
        alert('Please check required fields.');
        return;
      }
      axios.put('/api/makers/'+ this.m_id, {
        m_name    : this.m_name,
        m_descri  : this.m_descri,
        m_image   : this.m_image,
        m_sort    : this.m_sort
      }).then((response) => {
        if(response.data.affectedRows == 1) {
          this.getData()
        }
      }).catch(e => {
        console.log(e)
      })
      var modal = document.querySelector('.edit-wrapper')
      modal.style.display = "none"
    },
    deleteClient() {
      axios.delete('/api/makers/' + this.m_id)
        .then((response) => {
          if(response.data.code) {
            console.log(response.data.sqlMessage)
          }else if(response.data.affectedRows == 1) {
            this.getData()
          }
        }).catch(e => {
          console.log(e)
        })
        var modal = document.querySelector('.edit-wrapper')
        modal.style.display = "none"
    },
    checkDrag(e) {
      console.log("Index change to: " + e.draggedContext.futureIndex);
    },
    updateOrder() {
      this.makers.map((maker, index) => {
        maker.m_sort = index + 1
      })

      axios.put('/api/makers/updateAll', {
        makers: this.makers
      }).then((response) => {
        this.getData()
        console.log(response)

      })
    }
  }
}
</script>
<style lang="scss" scoped>
.worklist-wrapper {
  margin: 0 auto;
  padding: 100px 30px;
  position: relative;
  max-width: 1500px;
  overflow-x: scroll;
  .openAdd {
    background: none;
    font-size: 25px;
    line-height: 33px;
    float: right;
    margin-right: 8px;
  }
  .table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    word-wrap: break-word;
    // table-layout: fixed;
    .t-row {
      &:nth-child(even) {
        background-color: #dddddd;
      }
      &.drag {
        cursor: -moz-grab;
        cursor: -webkit-grab;
        cursor: grab;
        transition: transform 0.25s cubic-bezier(0.02, 1.01, 0.94, 1.01);
        will-change: transform;
        
        &:hover {
          transition: transform 0.25s cubic-bezier(0.02, 1.01, 0.94, 1.01);
          will-change: transform;
          transform: scale(1.01);
        }
      }
      th {
        color: #dae8ec;
      }
      td {
        height: 130px;
        vertical-align: middle;
      }
      td, th {
        border: 1px solid #eeeeee;
        text-align: left;
        padding: 15px; 
        font-size: 13px;
        max-width: 330px;

        &:first-child {
          min-width: 43px;
        }
        &:nth-child(2) {
          min-width: 150px;
        }
        &:nth-child(3) {
          min-width: 340px;
        }
        &:nth-child(4) {
          min-width: 340px;
        }
        &:nth-child(5) {
          min-width: 190px;
        }
        &:nth-child(6) {
          min-width: 190px;
        }
        &:nth-child(7) {
          min-width: 77px;
        }
        // &:nth-child(8) {
        //   min-width: 77px;
        // }
        &:last-child {
          min-width: 77px;
        }
        &.edit{
          width: 63px;
          text-align: center;
          button{
            background-color: #dae8ec;
            border-radius: 5px;
          }
        }
      }
    }
  }
}
.edit-wrapper {
  display: none;
  position: fixed;
  background-color: #eeeeee;
  padding-top: 70px;
  top: 0;
  left: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,.5); 
  .edit-inner {
    background-color: #fefefe;
    margin: auto;
    padding: 50px 50px 80px 50px;
    border: 1px solid #888;
    width: 35%;
    position: relative;
    .closeModal {
      border-radius: 6px;
    }
    .input-row {
      margin-bottom: 20px;
    }
    label {
      width: 120px;
    }
    h2 {
      margin-bottom: 30px;
    }
    input, textarea {
      width: 100%;
      font-size: 13px;
      padding: 3px;
    }
    #m_descri, #m_image {
      border-color:rgb(186,186,186);
    }
    .closeModal {
      position: absolute;
      padding: 5px;
      width: 40px;
      background: none;
      font-size: 17px;
      right: 50px;
      top: 50px;
      margin: 0;
    }
    
    button {
      width: 100px;
      padding: 5px 15px;
      background: none;
      // position: absolute;
      // top: 555px;
      // right: 50px;
      float: right;
      margin: 12px 0 0 15px;
    }
    .deleteClient {
      color: #fff;
      background-color: #eb8b57;
      // right: 164px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/worklist.vue